import * as React from "react";
import "./SessionSelect.component.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { useSessionListStore, updateSessionListStore, startSessionListPolling, stopSessionListPolling } from "../../store/sessionlist.store";
import Select from "react-select";
import { SessionSelectOption as Option } from "./session-select-option/SessionSelectOption.component";
import { getReactSelectStyleClasses } from "../../style/style-functions";
import { HTMLTooltipWrapper } from "../html-tooltip/HTMLTooltipWrapper.component";
import { useTranslation } from "react-i18next";
export function SessionSelect(props) {
    const { sessionName, onSelectionChanged, onCreateClicked, deleteVisible } = props;
    const sessionList = useSessionListStore((state) => state.sessions);
    const [sortedSessionList, setSortedSessionList] = useState([]);
    const [selectedSession, setSelectedSession] = useState(undefined);
    const { t } = useTranslation();
    useEffect(() => {
        if ((sessionList === null || sessionList === void 0 ? void 0 : sessionList.length) > 0) {
            function compareSessions(a, b) {
                if (a.participantCount === b.participantCount) {
                    return a.name.localeCompare(b.name);
                }
                return b.participantCount - a.participantCount;
            }
            setSortedSessionList(sessionList.sort(compareSessions));
        }
        else {
            setSortedSessionList([]);
        }
    }, [sessionList]);
    useEffect(() => {
        if ((sortedSessionList === null || sortedSessionList === void 0 ? void 0 : sortedSessionList.length) > 0) {
            if (sessionName) {
                const session = sortedSessionList.find((session) => session.name === sessionName);
                if (session) {
                    setSelectedSession(toOptionValue(session));
                    onSelectionChanged(session);
                }
            }
            else {
                setSelectedSession(toOptionValue(sortedSessionList[0]));
                onSelectionChanged(sortedSessionList[0]);
            }
        }
        else {
            setSelectedSession(undefined);
            onSelectionChanged(undefined);
        }
    }, [sessionName, sortedSessionList]);
    useEffect(() => {
        void updateSessionListStore();
        startSessionListPolling();
        return () => {
            stopSessionListPolling();
        };
    }, []);
    const handleSelectionChange = (option) => {
        if (option && option.session) {
            setSelectedSession(option);
            onSelectionChanged(option.session);
        }
    };
    const deleteSession = (session) => {
        if (deleteVisible) {
            props.onDeleteClicked(session);
        }
    };
    const toOptionValue = (session) => ({
        value: session.name,
        label: session.name,
        session: session,
        deleteVisible: deleteVisible !== null && deleteVisible !== void 0 ? deleteVisible : false,
        onDeleteClicked: deleteSession
    });
    const createOptionValues = () => sortedSessionList.map((session) => toOptionValue(session));
    return (React.createElement("section", { className: "session-select" },
        React.createElement(HTMLTooltipWrapper, { tooltip: t("common:session-select-tooltip", "Select a session to enter") },
            React.createElement(Select, { components: { Option }, value: selectedSession !== null && selectedSession !== void 0 ? selectedSession : "", options: createOptionValues(), classNames: getReactSelectStyleClasses(), onChange: (option) => {
                    handleSelectionChange(option);
                }, menuPlacement: "auto", menuPortalTarget: document.body })),
        React.createElement("button", { className: "icon-button highlight-button", onClick: onCreateClicked, "data-tooltip": t("common:session-select-button-new-tooltip", "Create a new session") },
            React.createElement(FontAwesomeIcon, { icon: ["fas", "plus"] }))));
}
